"use strict";
// Min-width property parser
// https://developer.mozilla.org/en-US/docs/Web/CSS/min-width
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const types_1 = require('../types.cjs');
const shared_sizing_1 = require('./shared-sizing.cjs');
/**
 * Parse a CSS min-width property string
 */
function parse(value) {
    return (0, shared_sizing_1.parseSizingProperty)(value, types_1.BASIC_SIZING_KEYWORDS, true);
}
/**
 * Convert a parsed min-width value back to CSS string
 */
function toCSSValue(parsed) {
    return (0, shared_sizing_1.sizingToCSSValue)(parsed);
}
